"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTokenClients = void 0;
var _PublicTokenClient = require("./PublicTokenClient");
var _UserTokenClient = require("./UserTokenClient");
var userTokenClient;
var publicTokenClient;
/**
 * Gets token clients for this package, this keeps client instances to minimal
 */ var getTokenClients = function() {
    userTokenClient !== null && userTokenClient !== void 0 ? userTokenClient : userTokenClient = new _UserTokenClient.UserTokenClient();
    publicTokenClient !== null && publicTokenClient !== void 0 ? publicTokenClient : publicTokenClient = new _PublicTokenClient.PublicTokenClient();
    return {
        userTokenClient: userTokenClient,
        publicTokenClient: publicTokenClient
    };
};
exports.getTokenClients = getTokenClients; //# sourceMappingURL=getTokenClients.js.map
